module.exports = __webpack_public_path__ + "img/garden.dd9beb5f.svg";